export const config = {
  rowSelection: false,
  columns: [
    {
      title: '编码',
      key: 'templateCode',
      dataIndex: 'templateCode',
      width: 200,
      ellipsis: {
        showTitle: true,
      }
    },
    {
      title: '模板名称',
      key: 'name',
      dataIndex: 'name',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '方向',
      key: 'paperDirectionName',
      dataIndex: 'paperDirectionName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '签字关键字',
      key: 'sealKeyName',
      dataIndex: 'sealKeyName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '盖章关键字',
      key: 'signKeyName',
      dataIndex: 'signKeyName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '创建时间',
      key: 'createdTime',
      dataIndex: 'createdTime',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
      itemType: 'dateTime'
    },
    {
      title: '创建人',
      key: 'createdByName',
      dataIndex: 'createdByName',
      width: 120,
    },
    {
      title: '状态',
      key: 'enable',
      dataIndex: 'enable',
      render: 'statusRender',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 224,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'name',
      label: '模板名称',
    },
  ],
  footer: [
    {
      label: '新增',
      // auth: 'priceButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
}
